// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HlBuetcTmVgHwLIlk7uY{min-height:32px;color:var(--content-primary-secondary)}.HlBuetcTmVgHwLIlk7uY.d74mqcYOtCYPQlVLoQ_8{background-color:transparent}.HlBuetcTmVgHwLIlk7uY:hover{background:var(--background-neutral-subtle);border-radius:6px}.HXy3WCOKFI8sEUleJuJL{padding:20px 0 8px}.kEhnvSAJKxYYv8Auowi5{padding:3px 0}.MCipQ7Lc_swHsHOAzpKx{color:var(--content-primary-tertiary);margin-top:2px}.eeh6qDypBSEfToW0ram1{justify-content:space-between;align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"conversationRadio": `HlBuetcTmVgHwLIlk7uY`,
	"checked": `d74mqcYOtCYPQlVLoQ_8`,
	"tabs": `HXy3WCOKFI8sEUleJuJL`,
	"messageField": `kEhnvSAJKxYYv8Auowi5`,
	"autoConvMessage": `MCipQ7Lc_swHsHOAzpKx`,
	"dataSourcesContainer": `eeh6qDypBSEfToW0ram1`
};
export default ___CSS_LOADER_EXPORT___;
